import api from "../../../app/api";
import {Bundle} from "./BundlesApi";

export interface LimitCounts {
  users: number;
  waivers: number;
  storage: number;
  submits: number;
  locations: number;
}

export async function getLimitCounts() {
  return api.get<{ success: boolean; data: LimitCounts; message: string }>(
    `/account/limit-counts`,
  );
}